import React, { useEffect } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import SuccessCircledArrow from 'shared/modules/ekyc/assets/images/success-circled-arrow.png';

type Props = {
  onFocus?: () => void;
  onBlur?: () => void;
};

const Success = (props: Props) => {
  const { onFocus, onBlur } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  return (
    <View style={styles.root}>
      <View style={[styles.imgContainer, !isBigScreen && { paddingTop: 88 }]}>
        <Image source={{ uri: SuccessCircledArrow }} style={styles.img} />
      </View>
      <View style={styles.content}>
        <Text style={styles.mainTitle}>
          {`本人確認のお手続き\nありがとうございました`}{' '}
        </Text>
        <Text style={styles.subtitle}>
          {`本人確認の結果は、手続き後\n通常数時間以内にメールでお知らせします。`}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  imgContainer: {
    paddingBottom: 24,
  },
  img: {
    height: 184,
    resizeMode: 'contain',
  },
  content: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#000',
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    fontWeight: '300',
    color: '#1C1C1C',
    textAlign: 'center',
  },
});

export default Success;
